import { render, staticRenderFns } from "./KpiSalesPie.vue?vue&type=template&id=c2ecdf72&"
import script from "./KpiSalesPie.vue?vue&type=script&lang=js&"
export * from "./KpiSalesPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports